import { makeAutoObservable } from "mobx";
import { GET, POST, GET_USER } from "../apis/apis";

class RatingStore {
  constructor({ errStore }) {
    makeAutoObservable(this);
    this.errStore = errStore;
  }

  ratings = [];
  rating = null;

  setRatings = (value) => {
    this.ratings = value;
  };

  setRating = (value) => {
    this.rating = value;
  };

  GetRatings = () => {
    this.errStore.setLoading(true);
    GET_USER(`/ratings`)
      .then((data) => {
        this.setRatings(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetRatingById = (id) => {
    this.errStore.setLoading(true);
    GET(`/rating/${id}`)
      .then((data) => {
        this.setRating(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  PostRating = async (values) => {
    try {
      const data = await POST("/rating", values);
      this.ratings.push(data);
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  };
}

export default RatingStore;
